import {Box, Text, VStack} from '@chakra-ui/react';
import {useServerConfig} from 'api/queries';
import RestaurantsSvg from 'assets/SVG/RestaurantsSvg';
import ShopSvg from 'assets/SVG/ShopSvg copy';
import {useDesktop, useLocalStorageState, useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import React from 'react';
import {colors} from 'theme';
import {ProviderTypeEnum, StorageKeyEnum} from 'types';
import ImageUI from 'ui/ImageUI';
import {openMobileStore} from 'utils/url';

const iconSize = '25px';
const NavRestShopDelivery = () => {
  const {t} = useTranslation();

  const [currentProvider, setCurrentProvider] = useLocalStorageState(StorageKeyEnum.CURRENT_PROVIDER);

  const {push} = useRouter();
  const {data: serverInfoConfig, isLoading: isLoadingServerInfoConfig} = useServerConfig();
  const showCourierExpress = serverInfoConfig?.show_courier_express && !isLoadingServerInfoConfig;

  const handleProviderType = React.useCallback(
    (providerType: ProviderTypeEnum) => {
      if (isLoadingServerInfoConfig) return;
      if (providerType !== ProviderTypeEnum.COURIER_EXPRESS) {
        setCurrentProvider(providerType);
        return push(`/`);
      }

      if (!showCourierExpress) return openMobileStore();
      if (providerType === ProviderTypeEnum.COURIER_EXPRESS) return push('/courier-express');
    },
    [isLoadingServerInfoConfig, push, setCurrentProvider, showCourierExpress],
  );

  const restStyle = {color: currentProvider === ProviderTypeEnum.RESTAURANT ? colors.pink : ''};
  const marketStyle = {color: currentProvider === ProviderTypeEnum.MARKET ? colors.pink : ''};
  const isDesktop = useDesktop();
  const minW = isDesktop ? 0 : '100px';

  return (
    <>
      <Box
        minW={minW}
        sx={restStyle}
        as="button"
        justifyItems="center"
        onClick={() => handleProviderType(ProviderTypeEnum.RESTAURANT)}
      >
        <VStack spacing={0}>
          <RestaurantsSvg fill={restStyle.color} />
          <Text fontSize="12px" textAlign="center" color={restStyle.color}>
            {t('restaurants')}
          </Text>
        </VStack>
      </Box>
      <Box
        minW={minW}
        sx={marketStyle}
        as="button"
        justifyItems="center"
        onClick={() => handleProviderType(ProviderTypeEnum.MARKET)}
      >
        <VStack spacing={0}>
          <ShopSvg fill={marketStyle.color} />
          <Text fontSize="12px" textAlign="center">
            {t('markets')}
          </Text>
        </VStack>
      </Box>
      <Box
        minW={minW}
        as="button"
        justifyItems="center"
        onClick={() => handleProviderType(ProviderTypeEnum.COURIER_EXPRESS)}
      >
        <VStack spacing={0}>
          <ImageUI width={iconSize} height={iconSize} src="/profile-menu/courier_express.svg" />
          <Text fontSize="12px" textAlign="center">
            {t('courier_express')}
          </Text>
        </VStack>
      </Box>
    </>
  );
};

export default NavRestShopDelivery;
